import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Back to the screen the member came from. The router numbers each history entry, so above 0 there
 * is an app screen behind this one. With none (opened from a link or a notification) go to
 * `fallback` instead, replacing this entry so back can't bounce between the two.
 *
 * Does nothing once the member has left this screen, so a save that finishes after they tapped
 * Back doesn't step back a second time.
 */
export function useNavigateBack(): (fallback: string) => void {
  const navigate = useNavigate();
  const { key } = useLocation();

  return (fallback) => {
    // The router leaves the first entry's key unset and calls it "default".
    const current = window.history.state ?? {};
    if ((current.key ?? 'default') !== key) return;

    if (current.idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  };
}
